<template>
  <v-row class="whyChoose-wrapper">
    <v-col>
      <v-row class="app-container--width-max mx-auto">
        <v-col cols="12">
          <h2>Why choose Paymentshield?</h2>
        </v-col>
        <v-col
          cols="12"
          class="d-flex flex-xl-wrap justify-space-between reason__item-wrapper pb-0"
        >
          <div
            class="reason__item"
            v-for="(reason, index) in whyChoose"
            :key="index"
          >
            <img
              :src="require(`@/assets/images/${reason.icon}`)"
              :alt="reason?.icon"
            />
            <h3 class="text-center">
              {{ reason?.title }}
            </h3>
            <p>
              {{ reason?.description }}
            </p>
          </div>
        </v-col>
        <v-col class="text-center btn-wrapper pt-0">
          <v-btn
            :ripple="false"
            depressed
            rounded
            color="mustard"
            x-large
            class="font-weight-bold font-18 text-uppercase mx-auto"
            @click="$emit('openCreateLLQuoteDialog')"
            aria-label="Get a new quote"
          >
            Get a new quote
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { WHY_CHOOSE } from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageWhyChoose",
  props: {
    whyChoose: {
      type: Array,
      default: () => WHY_CHOOSE,
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.whyChoose-wrapper {
  background: #eff0f0;
  padding: 44px 0 46px 0;
  h2 {
    margin-bottom: 8px;
  }
  .reason__item {
    max-width: 320px;
    min-height: 414px;
    border-radius: 10px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    background: #fff;
    img {
      max-width: 100%;
    }
    h3 {
      padding: 13px 25px 14px 25px;
    }
    p {
      padding: 0 25px 37px 25px;
      margin-bottom: 0;
    }
  }
  .v-btn {
    margin-top: -8px;
  }
}

@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .whyChoose-wrapper {
    padding: 8px 0 28px 0;
    .reason__item-wrapper {
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .reason__item {
        margin-bottom: 24px;
        min-width: 320px;
        margin-right: 14px;
      }
    }
    .col {
      padding: 12px 0 12px 12px;
      .app-container--width-max {
        padding-right: 0 !important;
        .col:not(.btn-wrapper) {
          padding-right: 0 !important;
        }
      }
      .btn-wrapper {
        padding-right: 40px !important;
      }
    }
  }
}
</style>
